import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import CustomButton from "./Button";

const ConfirmationPopup = ({ open, onClose, onConfirm, reason, message }) => {
  const [reasonText, setReasonText] = useState("");

  useEffect(() => {
    if (!open) setReasonText("");
  }, [open]);

  const isReasonRequired = Boolean(reason);

  const handleConfirm = () => {
    if (isReasonRequired && !reasonText.trim()) return;
    onConfirm(reasonText);
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="xs"
      PaperProps={{ sx: { borderRadius: 3, width: "100%" } }}
    >
      <DialogTitle
        sx={{
          fontWeight: 700,
          fontSize: 20,
          color: "primary.main",
          textAlign: "center",
          pb: 1,
        }}
      >
        Are you sure?
      </DialogTitle>

      <DialogContent sx={{ px: 3, pb: 1, textAlign: "center" }}>
        <Typography variant="body1" color="textSecondary">
          {message || "Are you sure you want to proceed?"}
        </Typography>

        {isReasonRequired && (
          <TextField
            label={reason || "Reason"}
            fullWidth
            required
            value={reasonText}
            onChange={(e) => setReasonText(e.target.value)}
            sx={{ mt: 2.5 }}
          />
        )}
      </DialogContent>

      <DialogActions sx={{ justifyContent: "center", p: 2.5, gap: 1.5 }}>
        <CustomButton
          text="No"
          variant="outlined"
          onClick={onClose}
          width="100px"
        />

        <CustomButton
          text="Yes"
          onClick={handleConfirm}
          width="100px"
          disabled={isReasonRequired && !reasonText.trim()}
        />
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationPopup;
